import { useCardsProductsStore } from '@lib/store';
import { CardUtils, cn, FormatUtils } from '@shared/utils';
import type { GetAllCardsResponse } from '@shared/api';

interface CardProps {
  className?: string;
  card: GetAllCardsResponse;
}

export const Card = (props: CardProps) => {
  const cardsProductsStore = useCardsProductsStore();

  return (
    <div
      className={cn(
        'h-63 w-100 cursor-pointer overflow-hidden rounded-2xl bg-contain',
        'max-md:aspect-320/205 max-md:h-auto max-md:w-auto max-md:bg-no-repeat',
        props.className,
      )}
      style={{ backgroundImage: `url(${CardUtils.renderBackgroundImg(props.card, cardsProductsStore.data)})` }}
    >
      <div className='mt-11.25 ml-5 pt-7.5 text-[29px] text-white'>
        <div style={{ color: CardUtils.getColor(props.card, cardsProductsStore.data) }}>{props.card.currency}</div>
      </div>
      <p
        className='mt-5 ml-6.5 text-xl tracking-[6px] whitespace-nowrap text-white max-md:text-[13px]'
        style={{ color: CardUtils.getColor(props.card, cardsProductsStore.data) }}
      >
        {FormatUtils.formatCardNumber(props.card.cardNumber)}
      </p>
      <p
        className='mt-5 ml-6.5 text-xl tracking-[6px] whitespace-nowrap text-white max-md:text-[13px]'
        style={{ color: CardUtils.getColor(props.card, cardsProductsStore.data) }}
      >
        {props.card.cardName}
      </p>
    </div>
  );
};
